/* The Farmers Box — theme scripts
   1. header / menu   2. postcode checker   3. basket (drawer, dock, bar, steppers, subscriptions)
   4. product page    5. account pages */
(function () {
  "use strict";

  var cfg = window.tfb || {};
  var routes = cfg.routes || {};
  var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(value) {
    return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function money(pence) {
    var n = Number(pence || 0) / 100;
    try { return n.toLocaleString("en-GB", { style: "currency", currency: "GBP" }); } catch (e) { return "£" + n.toFixed(2); }
  }
  function ordinal(day) {
    if (day % 10 === 1 && day !== 11) return day + "st";
    if (day % 10 === 2 && day !== 12) return day + "nd";
    if (day % 10 === 3 && day !== 13) return day + "rd";
    return day + "th";
  }
  function store(key, value) {
    try { if (value == null) localStorage.removeItem(key); else localStorage.setItem(key, value); } catch (e) {}
  }
  function recall(key) {
    try { return localStorage.getItem(key) || ""; } catch (e) { return ""; }
  }

  /* ---------- toast ---------- */
  var toastEl = $("[data-toast]");
  var toastTimer;
  function toast(message, isError) {
    if (!toastEl) return;
    toastEl.innerHTML = message;
    toastEl.classList.toggle("is-error", !!isError);
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, isError ? 4500 : 2600);
  }

  /* ---------- 0. header height for sticky offsets ---------- */
  (function headerHeight() {
    var header = $("[data-header]");
    if (!header) return;
    function set() { document.documentElement.style.setProperty("--header-h", header.offsetHeight + "px"); }
    set();
    window.addEventListener("resize", set, { passive: true });
    window.addEventListener("load", set);
  })();

  /* ---------- 1. header / menu ---------- */
  (function menu() {
    var toggle = $("[data-menu-toggle]");
    var menuEl = $("[data-mobile-nav]");
    var header = $("[data-header]");
    var wrapper = header && header.parentElement;

    // Shadow on the pinned header once the page scrolls.
    if (wrapper) {
      var onScroll = function () { wrapper.classList.toggle("is-scrolled", window.scrollY > 8); };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    if (!toggle || !menuEl) return;
    var panel = $(".mobile-menu-panel", menuEl);
    var closeTimer;
    function focusables() {
      return $$('a[href], button:not([disabled]):not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      clearTimeout(closeTimer);
      menuEl.hidden = false;
      document.body.classList.add("menu-open");
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      requestAnimationFrame(function () { requestAnimationFrame(function () { menuEl.classList.add("is-open"); }); });
      var first = $(".mobile-menu-close", menuEl);
      setTimeout(function () { if (first) first.focus(); }, 60);
    }
    function close(returnFocus) {
      menuEl.classList.remove("is-open");
      document.body.classList.remove("menu-open");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      closeTimer = setTimeout(function () { menuEl.hidden = true; }, reduceMotion ? 0 : 320);
      if (returnFocus !== false) toggle.focus();
    }
    toggle.addEventListener("click", function () { if (menuEl.hidden || !menuEl.classList.contains("is-open")) open(); else close(); });
    menuEl.addEventListener("click", function (e) {
      if (e.target.closest("[data-menu-close]")) { close(); return; }
      var link = e.target.closest("a[href]");
      if (link && link.getAttribute("href").indexOf("#") > -1) close(false); // same-page anchors: close so the jump is visible
    });
    document.addEventListener("keydown", function (e) {
      if (menuEl.hidden) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var list = focusables(); if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener("resize", function () { if (window.innerWidth >= 900 && !menuEl.hidden) close(false); });
  })();

  /* ---------- 2. postcode checker ---------- */
  var postcode = (function () {
    var map = null;      // { sectors: {L396: 'Friday'}, exact: {L397LD: 'Wednesday'} }
    var loading = null;
    var leadDays = Number(cfg.leadDays == null ? 1 : cfg.leadDays);
    var cutoffHour = Number(cfg.cutoffHour == null ? 12 : cfg.cutoffHour);

    function compact(value) { return String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); }
    function pretty(key) {
      if (key.length <= 5 && !/[A-Z]{2}$/.test(key)) return key.slice(0, -1) + " " + key.slice(-1);
      return key.slice(0, -3) + " " + key.slice(-3);
    }
    function load() {
      if (map) return Promise.resolve(map);
      if (loading) return loading;
      loading = fetch(cfg.postcodes, { credentials: "omit" })
        .then(function (r) { if (!r.ok) throw new Error("postcodes"); return r.json(); })
        .then(function (data) {
          map = { sectors: {}, exact: {}, districts: {}, prefixes: [] };
          var seen = {};
          Object.keys(data).forEach(function (k) {
            var day = String(data[k] || "").trim();
            if (/\*$/.test(k)) { map.prefixes.push(compact(k)); return; }   // Shopify local delivery style, e.g. "WA118*"
            var key = compact(k);
            if (/[A-Z]{2}$/.test(key) && key.length >= 5) {
              map.exact[key] = day;
              map.sectors[key.slice(0, -2)] = map.sectors[key.slice(0, -2)] || day;
            } else {
              map.sectors[key] = day;
            }
            // Remember the district's day when every sector in it shares one.
            var district = key.replace(/\d[A-Z]{0,2}$/, "");
            if (!(district in seen)) { seen[district] = day; } else if (seen[district] !== day) { seen[district] = ""; }
          });
          Object.keys(seen).forEach(function (d) { if (seen[d]) map.districts[d] = seen[d]; });
          return map;
        })
        .catch(function (e) { loading = null; throw e; });
      return loading;
    }
    // Returns { covered: bool, day: "Wednesday" | "" }. A postcode is covered when it is listed
    // or falls inside a delivery zone; the day comes from its sector, else its district.
    function dayFor(key) {
      var res = { covered: false, day: "" };
      if (!map) return res;
      var isFull = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(key);
      var sector = isFull ? key.slice(0, -2) : key;
      var district = sector.slice(0, -1);
      var day = map.exact[key] || map.sectors[sector] || map.districts[district] || "";
      var inZone = map.prefixes.some(function (p) { return sector.indexOf(p) === 0 || key.indexOf(p) === 0; });
      // With delivery zones listed, they decide coverage; otherwise only listed sectors count.
      res.covered = map.prefixes.length ? inZone : !!day;
      res.day = res.covered ? day : "";
      return res;
    }
    function nextDate(dayName) {
      var target = DAYS.indexOf(dayName);
      if (target < 0) return null;
      var now = new Date();
      var earliest = new Date(now.getTime());
      earliest.setHours(12, 0, 0, 0);
      var offset = leadDays + (now.getHours() >= cutoffHour ? 1 : 0);
      earliest.setDate(earliest.getDate() + offset);
      var d = new Date(earliest.getTime());
      d.setDate(d.getDate() + ((target - d.getDay() + 7) % 7));
      return d;
    }
    function format(d) { return DAYS[d.getDay()] + " " + ordinal(d.getDate()) + " " + MONTHS[d.getMonth()]; }
    function nextLabel(dayName) {
      var d = nextDate(dayName);
      return d ? format(d) : dayName;
    }
    function remember(day, code) {
      store("tfb-delivery-day", day || null);
      store("tfb-postcode", code || null);
      document.dispatchEvent(new CustomEvent("tfb:delivery", { detail: { day: day || "" } }));
    }
    function check(value, out) {
      var key = compact(value);
      var isFull = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(key);
      // A sector ("L39 6") needs its space, so "L39" on its own isn't read as L3 9.
      var isSector = /\s/.test(String(value).trim()) && /^[A-Z]{1,2}\d[A-Z\d]?\d$/.test(key);
      if (!isFull && !isSector) {
        out.classList.remove("is-yes");
        out.textContent = "Enter a full postcode, such as L39 6SY.";
        return;
      }
      out.textContent = "Checking…";
      load().then(function () {
        var found = dayFor(key);
        var day = found.day;
        var shown = pretty(key);
        if (found.covered && day) {
          remember(day, shown);
          out.classList.add("is-yes");
          out.innerHTML = "Yes, we deliver to <strong>" + esc(shown) + "</strong> on " + esc(day) + "s. Next delivery: <strong>" + esc(nextLabel(day)) + "</strong>.";
        } else if (found.covered) {
          remember("", shown);
          out.classList.add("is-yes");
          out.innerHTML = "Yes, we deliver to <strong>" + esc(shown) + "</strong>. We’ll confirm your delivery day by email once you’ve ordered.";
        } else {
          remember("", "");
          out.classList.remove("is-yes");
          var contact = out.getAttribute("data-contact-url") || "/pages/contact";
          out.innerHTML = "We don’t have " + esc(shown) + " on the round yet. If you’re close by, <a href=\"" + esc(contact) + "\">write to us</a> and we’ll see what we can do, or collect from the farm shop.";
        }
      }).catch(function () {
        out.classList.remove("is-yes");
        out.textContent = "The postcode list did not load. Please try again in a moment.";
      });
    }
    $$("[data-postcode-form]").forEach(function (form) {
      var input = form.querySelector("input[name=postcode]");
      var out = form.querySelector("[data-postcode-result]") || (form.parentNode && form.parentNode.querySelector("[data-postcode-result]"));
      if (!input || !out) return;
      var saved = recall("tfb-postcode");
      if (saved && !input.value) input.value = saved;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        check(input.value, out);
      });
    });
    return { nextLabel: nextLabel, savedDay: function () { return recall("tfb-delivery-day"); } };
  })();

  /* ---------- 3. basket ---------- */
  (function basket() {
    var drawer = $("[data-cart-drawer]");
    var panel = drawer && $("[data-cart-panel]", drawer);
    var linesEl = drawer && $("[data-cart-lines]", drawer);
    var countEl = $("[data-cart-count]");
    var cartBtn = $(".cart-btn");
    var bar = $("[data-cart-bar]");
    var noteEl = $("[data-cart-note]");
    var cart = { items: [], item_count: 0, total_price: 0, attributes: {}, note: "" };
    var desired = {};   // variantId -> wanted quantity (optimistic)
    var syncing = {};
    var queued = {};
    var opener = null;
    var shopLink = $("[data-cart-close-link]");
    var shopUrl = shopLink ? shopLink.getAttribute("href") : "/";
    var plans = {};     // variantId -> selling plan id (from cards on the page)
    $$("[data-variant][data-selling-plan]").forEach(function (n) { plans[n.getAttribute("data-variant")] = n.getAttribute("data-selling-plan"); });

    function api(url, body) {
      return fetch(url, {
        method: body ? "POST" : "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) { var err = new Error(data.description || data.message || "Something went wrong"); err.data = data; throw err; }
          return data;
        });
      });
    }
    function load() { return api((routes.cart || "/cart") + ".js").then(apply); }
    function apply(next) {
      if (next && Array.isArray(next.items)) cart = next;
      paint();
      return cart;
    }
    function mode() {
      var saved = cart.attributes && cart.attributes.Delivery;
      return saved === "Every week" || saved === "Weekly Subscription" ? "week" : "once";
    }
    function linesFor(id) {
      return cart.items.filter(function (i) { return String(i.variant_id || i.id) === String(id); });
    }
    function lineFor(id) { return linesFor(id)[0] || null; }
    function lineForKey(key) {
      for (var i = 0; i < cart.items.length; i += 1) if (cart.items[i].key === key) return cart.items[i];
      return null;
    }
    function shownQty(id) {
      if (Object.prototype.hasOwnProperty.call(desired, id)) return desired[id];
      return linesFor(id).reduce(function (n, l) { return n + l.quantity; }, 0);
    }
    function totals() {
      var count = 0, total = 0, seen = {};
      cart.items.forEach(function (item) {
        var id = String(item.variant_id || item.id);
        if (seen[id]) return;
        seen[id] = true;
        var qty = shownQty(id);
        count += qty;
        total += Math.round((item.final_price || item.price || 0) * qty);
      });
      $$("[data-variant][data-price]").forEach(function (node) {
        var id = node.getAttribute("data-variant");
        if (seen[id]) return;
        seen[id] = true;
        var qty = shownQty(id);
        if (!qty) return;
        count += qty;
        total += qty * Number(node.getAttribute("data-price") || 0);
      });
      return { count: count, total: total };
    }

    function paintWhen() {
      var day = postcode.savedDay();
      $$("[data-next-delivery]").forEach(function (n) { n.textContent = day ? postcode.nextLabel(day) : "Check your postcode"; });
      $$("[data-next-delivery-inline]").forEach(function (n) { n.textContent = day ? postcode.nextLabel(day) + "." : "set by your postcode."; });
      $$("[data-cart-when]").forEach(function (n) { n.hidden = !day; });
    }
    function paintMode() {
      var m = mode();
      $$("[data-delivery]").forEach(function (b) {
        var on = b.getAttribute("data-delivery") === m;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });
      $$("[data-delivery-note]").forEach(function (n) {
        n.textContent = m === "week"
          ? "We’ll pack this order on every round until you ask us to stop. Call or email to change it."
          : "A single delivery. Choose Every week to have the same order repeat on your round.";
      });
    }
    function lineHtml(item) {
      var id = String(item.variant_id || item.id);
      var qty = shownQty(id);
      if (!qty) return "";
      var image = item.image ? '<img src="' + esc(item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=180") + '" alt="" width="72" height="72" loading="lazy">' : '<span class="cart-photo"></span>';
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? '<span class="plan-tag">' + esc(item.selling_plan_allocation.selling_plan.name) + '</span>' : "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? '<p class="moss">' + esc(item.variant_title) + '</p>' : "";
      return '<article class="cart-line" data-key="' + esc(item.key) + '" data-variant-line="' + esc(id) + '">' +
        image +
        '<div><p class="cart-line-title">' + esc(item.product_title || item.title) + '</p>' + variant + plan +
          '<div class="qty"><button type="button" data-line-minus aria-label="Fewer ' + esc(item.product_title) + '">&minus;</button><span>' + qty + '</span><button type="button" class="qty-plus" data-line-plus aria-label="More ' + esc(item.product_title) + '">+</button></div>' +
        '</div>' +
        '<div><p class="cart-line-price">' + money((item.final_price || item.price || 0) * qty) + '</p><button type="button" class="cart-line-remove" data-line-remove>Remove</button></div>' +
      '</article>';
    }
    function paint() {
      var t = totals();
      var label = t.count === 1 ? "1 item" : t.count + " items";
      if (countEl) { countEl.textContent = String(t.count); countEl.setAttribute("data-count", String(t.count)); }
      $$("[data-cart-count-label]").forEach(function (n) { n.textContent = label; });
      $$("[data-cart-total]").forEach(function (n) { n.textContent = money(t.total); });
      $$("[data-plan-total]").forEach(function (n) { n.textContent = money(t.total); });
      $$("[data-cart-dock-count]").forEach(function (n) { n.textContent = label; });
      $$("[data-cart-dock-empty]").forEach(function (n) { n.hidden = t.count > 0; });
      $$("[data-cart-bar-count]").forEach(function (n) { n.textContent = label + " in your basket"; });
      $$("[data-cart-bar-total]").forEach(function (n) { n.textContent = money(t.total); });
      $$("[data-cart-checkout]").forEach(function (n) { n.classList.toggle("is-disabled", t.count === 0); n.setAttribute("aria-disabled", t.count === 0 ? "true" : "false"); });
      if (bar) { bar.hidden = t.count === 0; document.body.classList.toggle("has-cart-bar", t.count > 0); }
      var dockLines = $("[data-cart-dock-lines]");
      if (dockLines) {
        dockLines.innerHTML = cart.items.map(function (item) {
          var qty = shownQty(String(item.variant_id || item.id));
          if (!qty) return "";
          return "<li><span>" + qty + "×</span><span>" + esc(item.product_title || item.title) + "</span><span>" + money((item.final_price || item.price || 0) * qty) + "</span></li>";
        }).join("");
      }
      $$("[data-variant]").forEach(function (node) {
        var q = shownQty(node.getAttribute("data-variant"));
        var v = node.querySelector("[data-qty-value]");
        if (v) v.textContent = String(q);
        node.classList.toggle("has-qty", q > 0);
      });
      if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || "";
      paintMode();
      paintWhen();
      if (!linesEl) return;
      if (!cart.items.length || !t.count) {
        linesEl.innerHTML = '<p class="cart-empty">Your basket is empty. <a href="' + esc(shopUrl) + '">Browse the farm shop</a>.</p>';
        return;
      }
      var seen = {};
      linesEl.innerHTML = cart.items.map(function (item) {
        var id = String(item.variant_id || item.id);
        if (seen[id]) return "";
        seen[id] = true;
        return lineHtml(item);
      }).join("");
    }

    /* --- changing quantities --- */
    function change(key, quantity, extra) {
      var body = { id: key, quantity: quantity };
      if (extra) Object.keys(extra).forEach(function (k) { body[k] = extra[k]; });
      return api((routes.cartChange || "/cart/change") + ".js", body).then(apply);
    }
    function add(id, quantity) {
      var item = { id: Number(id), quantity: quantity };
      if (!plans[id]) { var planHost = document.querySelector('[data-variant="' + id + '"][data-selling-plan]'); if (planHost) plans[id] = planHost.getAttribute("data-selling-plan"); }
      if (mode() === "week" && plans[id]) item.selling_plan = Number(plans[id]);
      return api((routes.cartAdd || "/cart/add") + ".js", { items: [item] }).then(load);
    }
    function sync(id) {
      if (syncing[id]) return;
      var want = desired[id];
      if (want == null) return;
      var lines = linesFor(id);
      var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
      if (want === have) { delete desired[id]; paint(); return; }
      syncing[id] = true;
      var request;
      if (!lines.length) request = add(id, want);
      else if (lines.length === 1) request = change(lines[0].key, want);
      else request = change(lines[0].key, Math.max(0, want - (have - lines[0].quantity)));
      request.then(function () {
        syncing[id] = false;
        var now = linesFor(id).reduce(function (n, l) { return n + l.quantity; }, 0);
        if (desired[id] != null && desired[id] !== now) sync(id); else delete desired[id];
        paint();
      }).catch(function (err) {
        syncing[id] = false;
        delete desired[id];
        toast(esc(err.message || "That did not go in the basket. Please try again."), true);
        load().catch(function () {});
      });
    }
    function queue(id) { clearTimeout(queued[id]); queued[id] = setTimeout(function () { sync(id); }, 120); }
    function bump(id, delta) {
      var before = shownQty(id);
      desired[id] = Math.max(0, before + delta);
      paint();
      queue(id);
      if (delta > 0 && cartBtn && !reduceMotion) {
        cartBtn.classList.add("is-bumped");
        setTimeout(function () { cartBtn.classList.remove("is-bumped"); }, 220);
      }
      var dlg = $("[data-details-dialog]");
      var dock = $("[data-cart-dock]");
      var dockShown = dock && dock.offsetParent !== null;
      var barShown = bar && !bar.hidden && getComputedStyle(bar).display !== "none";
      if (delta > 0 && barShown && !reduceMotion) {
        bar.classList.remove("is-pulsed"); void bar.offsetWidth; bar.classList.add("is-pulsed");
      }
      if (delta > 0 && before === 0 && drawer && drawer.hidden && !(dlg && dlg.open) && !dockShown && !barShown) {
        var card = document.querySelector('[data-variant="' + id + '"]');
        var title = card && card.getAttribute("data-title");
        if (title) toast(esc(title) + " added to your basket");
      }
    }

    /* --- subscription mode --- */
    function setMode(next) {
      var label = next === "week" ? "Every week" : "Just once";
      cart.attributes = cart.attributes || {};
      cart.attributes.Delivery = label;
      paintMode();
      var attrs = {};
      attrs.Delivery = label;
      api((routes.cartUpdate || "/cart/update") + ".js", { attributes: attrs }).then(apply).then(function () {
        // move lines on to / off a selling plan where we know one
        var work = Promise.resolve();
        cart.items.forEach(function (item) {
          var id = String(item.variant_id || item.id);
          var hasPlan = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
          if (next === "week" && !hasPlan && plans[id]) {
            work = work.then(function () { return change(item.key, item.quantity, { selling_plan: Number(plans[id]) }); });
          } else if (next === "once" && hasPlan) {
            work = work.then(function () { return change(item.key, item.quantity, { selling_plan: null }); });
          }
        });
        return work;
      }).then(function () {
        toast(next === "week" ? "Your order will repeat every week" : "Set to a single delivery");
      }).catch(function (err) { toast(esc(err.message || "Could not update the basket"), true); });
    }

    /* --- note --- */
    var noteTimer;
    if (noteEl) {
      noteEl.addEventListener("input", function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          api((routes.cartUpdate || "/cart/update") + ".js", { note: noteEl.value }).then(function (data) { cart.note = data.note || noteEl.value; }).catch(function () {});
        }, 600);
      });
    }

    /* --- drawer --- */
    function focusables() {
      return $$('a[href], button:not([disabled]), textarea, input, select, summary, [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      if (!drawer) return;
      opener = document.activeElement;
      if (toastEl) toastEl.hidden = true;
      drawer.hidden = false;
      document.body.style.overflow = "hidden";
      var close = $("[data-cart-close]:not(.cart-backdrop)", drawer);
      setTimeout(function () { (close || panel).focus(); }, 20);
    }
    function close() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.style.overflow = "";
      if (opener && opener.focus) opener.focus();
    }
    if (drawer) {
      drawer.addEventListener("click", function (e) { if (e.target.closest("[data-cart-close]")) close(); });
      document.addEventListener("keydown", function (e) {
        if (drawer.hidden) return;
        if (e.key === "Escape") { close(); return; }
        if (e.key !== "Tab") return;
        var list = focusables();
        if (!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-cart-open]")) {
        e.preventDefault();
        var openDialog = $("[data-details-dialog]");
        if (openDialog && openDialog.open) openDialog.close();
        load().then(open).catch(open);
        return;
      }
      var checkout = t.closest("[data-cart-checkout]");
      if (checkout && checkout.classList.contains("is-disabled")) { e.preventDefault(); toast("Add something to the basket first"); return; }
      var plan = t.closest("[data-delivery]");
      if (plan) { setMode(plan.getAttribute("data-delivery")); return; }
      var plus = t.closest("[data-qty-plus]"), minus = t.closest("[data-qty-minus]");
      var host = (plus || minus) && (plus || minus).closest("[data-variant]");
      if (host && !host.closest("[data-product-form]")) { bump(host.getAttribute("data-variant"), plus ? 1 : -1); return; }
      var more = t.closest("[data-line-plus]"), less = t.closest("[data-line-minus]"), remove = t.closest("[data-line-remove]");
      var row = (more || less || remove) && (more || less || remove).closest("[data-key]");
      if (!row) return;
      var line = lineForKey(row.getAttribute("data-key"));
      if (!line) return;
      var id = String(line.variant_id || line.id);
      if (remove) { desired[id] = 0; paint(); queue(id); return; }
      bump(id, more ? 1 : -1);
    });

    document.addEventListener("tfb:delivery", paintWhen);
    document.addEventListener("tfb:cart", function (e) { if (e.detail && e.detail.open) { load().then(open).catch(open); } else { load().catch(function () {}); } });
    load().catch(function () { paint(); });
    window.tfbCart = { load: load, open: open, toast: toast };
  })();


  /* ---------- 3b. product details pop-up ---------- */
  (function details() {
    var dialog = $("[data-details-dialog]");
    if (!dialog || typeof dialog.showModal !== "function") {
      // No <dialog> support: "details" buttons fall back to the product page.
      $$("[data-details-open]").forEach(function (b) {
        b.addEventListener("click", function () {
          var a = b.closest("[data-product-card]").querySelector(".pcard-title a");
          if (a) window.location.href = a.href;
        });
      });
      return;
    }
    var host = $("[data-details-host]", dialog);
    var body = $("[data-details-body]", dialog);
    var lastOpener = null;
    function show(card, opener) {
      var tpl = card.querySelector("template[data-details]");
      if (!tpl) return;
      body.innerHTML = "";
      body.appendChild(tpl.content.cloneNode(true));
      var title = body.querySelector("[data-details-title]");
      if (title) title.id = "DetailsTitle";
      ["data-variant", "data-price", "data-title", "data-selling-plan"].forEach(function (attr) {
        if (card.hasAttribute(attr)) host.setAttribute(attr, card.getAttribute(attr)); else host.removeAttribute(attr);
      });
      var soldOut = card.classList.contains("is-sold-out");
      $(".details-buy", dialog).hidden = soldOut;
      lastOpener = opener;
      dialog.showModal();
      document.body.style.overflow = "hidden";
      if (window.tfbCart) window.tfbCart.load().catch(function () {});
      dialog.scrollTop = 0;
      $("[data-details-close]", dialog).focus();
    }
    dialog.addEventListener("close", function () {
      document.body.style.overflow = "";
      host.removeAttribute("data-variant");
      if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    });
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog || e.target.closest("[data-details-close]")) dialog.close();
    });
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-details-open]");
      if (!btn) return;
      var card = btn.closest("[data-product-card]");
      if (card) show(card, btn);
    });
  })();

  /* ---------- 3c. shop category menu ---------- */
  (function shopNav() {
    var nav = $("[data-shop-nav]");
    if (!nav) return;
    var links = $$("[data-shop-nav-link]", nav);
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute("href").slice(1)); });
    var activeIndex = -1;
    function setActive(i) {
      if (i === activeIndex) return;
      activeIndex = i;
      links.forEach(function (a, j) {
        var on = j === i;
        a.classList.toggle("is-active", on);
        if (on) { a.setAttribute("aria-current", "true"); } else { a.removeAttribute("aria-current"); }
      });
      var active = links[i];
      var inner = active && active.parentNode;
      if (inner && inner.scrollWidth > inner.clientWidth && inner.scrollTo) {
        inner.scrollTo({ left: Math.max(0, active.offsetLeft - 16), behavior: reduceMotion ? "auto" : "smooth" });
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (Date.now() < lockUntil) return;
        var line = nav.getBoundingClientRect().bottom + 90;
        var current = 0, rowTop = null;
        targets.forEach(function (el, i) {
          if (!el) return;
          var top = el.getBoundingClientRect().top;
          if (top > line) return;
          if (rowTop === null || Math.abs(top - rowTop) > 4) { current = i; rowTop = top; }
        });
        setActive(current);
        nav.classList.toggle("is-stuck", nav.getBoundingClientRect().top <= (parseFloat(getComputedStyle(nav).top) || 0) + 1);
      });
    }
    var lockUntil = 0;
    links.forEach(function (a, i) {
      a.addEventListener("click", function () { lockUntil = Date.now() + 1200; activeIndex = -1; setActive(i); });
    });
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();


  /* ---------- 6. home page: reveal, count-up, journey, seasons, box finder, day match ---------- */
  (function home() {
    // Scroll reveal. Only hides things once we know we can show them again.
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (!reduceMotion && !designMode && "IntersectionObserver" in window) {
      var auto = ".facts dl > div, .day-cards .note-card, .cards .card, .split-grid > *, .faq-item, .journey-steps, .forest .grid > *";
      $$(auto).forEach(function (el) { if (!el.hasAttribute("data-reveal")) el.classList.add("reveal-item"); });
      var items = $$("[data-reveal], .reveal-item");
      items.forEach(function (el) {
        var sibs = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (c) { return c.classList.contains("reveal-item") || c.hasAttribute("data-reveal"); }) : [];
        var i = sibs.indexOf(el);
        if (i > 0) el.style.setProperty("--reveal-delay", Math.min(i, 5) * 0.08 + "s");
      });
      document.documentElement.classList.add("js-reveal");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
      // Anything already on screen (or above it) shows straight away.
      function revealPassed() {
        items.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-visible"); });
      }
      requestAnimationFrame(revealPassed);
      // Safety nets: never leave content hidden.
      window.addEventListener("scroll", function () { requestAnimationFrame(revealPassed); }, { passive: true });
      window.addEventListener("beforeprint", function () { items.forEach(function (el) { el.classList.add("is-visible"); }); });
      document.addEventListener("visibilitychange", function () { if (document.hidden) items.forEach(function (el) { el.classList.add("is-visible"); }); });
    }

    // Count up the leading number in the facts strip (e.g. "40+ Years").
    if (!reduceMotion && "IntersectionObserver" in window) {
      $$(".facts dt").forEach(function (dt) {
        var m = dt.textContent.match(/^(\d+)(.*)$/);
        if (!m) return;
        var target = Number(m[1]), rest = m[2];
        var cio = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          cio.disconnect();
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var p = Math.min(1, (ts - start) / 1100);
            dt.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + rest;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, { threshold: 0.6 });
        cio.observe(dt);
      });
    }

    // Generic accessible tabs (journey + seasons).
    function tabs(root, tabSel, panelSel, onChange) {
      var t = $$(tabSel, root), p = $$(panelSel, root);
      function select(i, focus) {
        t.forEach(function (tab, j) {
          var on = i === j;
          tab.classList.toggle("is-on", on);
          tab.classList.toggle("is-done", j < i);
          tab.setAttribute("aria-selected", on ? "true" : "false");
          tab.tabIndex = on ? 0 : -1;
          if (p[j]) p[j].hidden = !on;
        });
        if (focus && t[i]) t[i].focus();
        if (onChange) onChange(i);
      }
      t.forEach(function (tab, i) {
        tab.addEventListener("click", function () { select(i); });
        tab.addEventListener("keydown", function (e) {
          var n = t.length, k = e.key, to = -1;
          if (k === "ArrowRight" || k === "ArrowDown") to = (i + 1) % n;
          if (k === "ArrowLeft" || k === "ArrowUp") to = (i - 1 + n) % n;
          if (k === "Home") to = 0;
          if (k === "End") to = n - 1;
          if (to > -1) { e.preventDefault(); select(to, true); }
        });
      });
      return { select: select, count: t.length };
    }

    $$("[data-journey]").forEach(function (root) {
      var current = 0;
      var api = tabs(root, "[data-journey-tab]", "[data-journey-panel]", function (i) { current = i; });
      root.addEventListener("click", function (e) {
        if (e.target.closest("[data-journey-next]") && current < api.count - 1) api.select(current + 1);
        if (e.target.closest("[data-journey-prev]") && current > 0) api.select(current - 1);
      });
    });

    $$("[data-seasons]").forEach(function (root) {
      var month = new Date().getMonth() + 1, nowIndex = -1;
      var seasonTabs = $$("[data-season-tab]", root);
      seasonTabs.forEach(function (tab, i) {
        var months = (tab.getAttribute("data-months") || "").split(",").map(Number);
        if (months.indexOf(month) > -1) nowIndex = i;
      });
      var panels = $$("[data-season-panel]", root);
      if (nowIndex > -1 && panels[nowIndex]) {
        var badge = panels[nowIndex].querySelector("[data-season-now]");
        if (badge) badge.hidden = false;
      }
      var api = tabs(root, "[data-season-tab]", "[data-season-panel]");
      if (nowIndex > -1) api.select(nowIndex);
    });

    $$("[data-finder]").forEach(function (root) {
      function pick() {
        var people = Number((root.querySelector("[data-finder-people]:checked") || {}).value || 1);
        var fruit = (root.querySelector("[data-finder-fruit]:checked") || {}).value === "yes";
        var key = fruit ? (people >= 3 ? "family" : "mixed") : (people >= 3 ? "large" : "small");
        var results = $$("[data-finder-result]", root);
        var target = root.querySelector('[data-finder-result="' + key + '"]') || results[0];
        results.forEach(function (r) { r.hidden = r !== target; });
      }
      root.addEventListener("change", function (e) { if (e.target.matches("[data-finder-people], [data-finder-fruit]")) pick(); });
      pick();
    });

    // Highlight the customer's delivery day once their postcode is known.
    function matchDay() {
      var day = postcode.savedDay();
      $$(".day-cards").forEach(function (wrap) {
        var any = false;
        $$("[data-day]", wrap).forEach(function (card) {
          var on = !!day && card.getAttribute("data-day").toLowerCase() === day.toLowerCase();
          card.classList.toggle("is-match", on);
          if (on) any = true;
        });
        wrap.classList.toggle("has-match", any);
      });
    }
    document.addEventListener("tfb:delivery", matchDay);
    matchDay();
  })();

  /* ---------- 4. product page ---------- */
  (function product() {
    var form = $("[data-product-form]");
    if (!form) return;
    var qtyInput = $("[data-qty-input]", form);
    var message = $("[data-form-message]", form);
    var button = $("[data-add-to-cart]", form);
    var select = $("[data-variant-select]", form);
    var price = $("[data-product-price] .display");

    form.addEventListener("click", function (e) {
      if (!qtyInput) return;
      if (e.target.closest("[data-qty-plus]")) { qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1); }
      if (e.target.closest("[data-qty-minus]")) { qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1); }
    });
    if (select && select.tagName === "SELECT" && price) {
      select.addEventListener("change", function () {
        var opt = select.options[select.selectedIndex];
        if (opt && opt.getAttribute("data-money")) price.textContent = opt.getAttribute("data-money");
      });
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!button) return;
      var fd = new FormData(form);
      var body = { id: Number(fd.get("id")), quantity: Math.max(1, Number(fd.get("quantity") || 1)) };
      var plan = fd.get("selling_plan");
      if (plan) body.selling_plan = Number(plan);
      button.classList.add("is-busy");
      if (message) message.textContent = "";
      fetch((routes.cartAdd || "/cart/add") + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [body] }) })
        .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || "Could not add that"); return data; }); })
        .then(function () {
          button.classList.remove("is-busy");
          if (message) message.innerHTML = "Added to your basket.";
          document.dispatchEvent(new CustomEvent("tfb:cart", { detail: { open: true } }));
        })
        .catch(function (err) {
          button.classList.remove("is-busy");
          if (message) message.textContent = err.message;
        });
    });

    var main = $("[data-product-main-image]");
    $$("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.src = thumb.getAttribute("data-src");
        main.srcset = thumb.getAttribute("data-srcset") || "";
        $$("[data-thumb]").forEach(function (t) { t.classList.toggle("is-on", t === thumb); });
      });
    });
  })();

  /* ---------- 5. account pages ---------- */
  (function account() {
    var show = $("[data-show-recover]"), hide = $("[data-hide-recover]"), recover = $("[data-recover-form]"), login = $("[data-login-form]");
    if (show && recover && login) {
      function swap(toRecover) { recover.hidden = !toRecover; login.hidden = toRecover; var f = (toRecover ? recover : login).querySelector("input"); if (f) f.focus(); }
      show.addEventListener("click", function (e) { e.preventDefault(); swap(true); });
      if (hide) hide.addEventListener("click", function (e) { e.preventDefault(); swap(false); });
      if (window.location.hash === "#recover") swap(true);
    }
    $$("[data-address-edit]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var box = document.getElementById("EditAddress-" + btn.getAttribute("data-address-edit"));
        if (!box) return;
        box.hidden = !box.hidden;
        btn.setAttribute("aria-expanded", box.hidden ? "false" : "true");
      });
    });
    $$("[data-address-delete]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { if (!window.confirm("Delete this address?")) e.preventDefault(); });
    });
    $$("select[data-default]").forEach(function (sel) {
      var want = sel.getAttribute("data-default");
      for (var i = 0; i < sel.options.length; i += 1) if (sel.options[i].value === want || sel.options[i].text === want) { sel.selectedIndex = i; break; }
    });
  })();
})();
